import { Component, Output, OnInit, OnDestroy } from '@angular/core';
import { FormGroupDirective, ControlContainer, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { UsedSgkc011aService } from '../../services/used-sgkc011a.service';
import { UsedSgkc012aService } from '../../services/used-sgkc012a.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Sgkc011aReqSlideadjustmentunitpriceSearchinfoDto, Sgkc011aRequest, Sgkc012aReqSlideadjustmentunitpriceShutokuinfoDto, Sgkc012aRequest, Sgkc016aReqSlideadjustmentunitpriceApprvInfoDto, Sgkc016aRequest, Sgkc019aReqSlideadjustmentunitpriceRegInfoDto, Sgkc019aRequest, Sgkc028aReqSlideadjustmentunitpriceCancelInfoDto, Sgkc028aRequest, SlideadjustmentunitpriceInfo, SlideadjustmentunitpriceLstInfoDto } from 'sg-api';
import { DisplayMode, TimeApiService } from 'cbc-shared-lib';
import { UsedSgkc019aService } from '../../services/used-sgkc019a.service';
import { UsedSgkc028aService } from '../../services/used-sgkc028a.service';
import { UsedSgkc016aService } from '../../services/used-sgkc016a.service';
import { SearchStat } from '../../../../../sg-kc-shared/constants/searchStat';
import { EnergyTypeCode } from '../../../../../sg-kc-shared/constants/energyTypeCode ';
import { CompleteDataService } from '../../../../../../sg-base/sg-base-shared/pages/sgkz003d/services/complete-data.service';
import { CompanyGroupCode } from '../../../../../sg-kc-shared/constants/companyGroupCode';
import { CompanyCode } from '../../../../../sg-kc-shared/constants/companyCode';
import { SlideadjustmentunitpriceCode } from '../../../../../sg-kc-shared/constants/slideadjustmentunitpriceCode';

/**
 * 再エネ賦課金単価登録画面
 * @exports
 * @class Sgkc034dComponent
 * @implements {OnInit, OnDestroy}
 */
@Component({
    selector: 'app-sgkc034d',
    templateUrl: './sgkc034d.component.html',
    styleUrl: './sgkc034d.component.scss',
    providers: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class Sgkc034dComponent implements OnInit, OnDestroy {
    /** エラーメッセージリスト */
    @Output() errorMessageModelArray: Array<SgAriaMessage>;
    /** 画面表示モード */
    mode: string;
    /** 子コンポーネントの入力内容受取Form */
    reEnergyTankaForm: UntypedFormGroup;
    /** 購読を停止するためのSubject */
    private onDestroy$ = new Subject();
    /** スライド調整単価一覧情報リスト */
    slideadjustmentunitpriceLstInformationlist: SlideadjustmentunitpriceLstInfoDto[];
    /** スライド調整単価情報 */
    slideadjustmentunitpriceInfo: SlideadjustmentunitpriceInfo;
    /** 再エネ賦課金単価承認情報表示フラグ */
    isVisibleApprovalInfo: boolean = false;
    /** 再エネ賦課金単価情報表示フラグ */
    isVisibleTankaInfo: boolean = false;
    /** 承認ステータスコード */
    apprvStatuscode: string;
    /** 再エネ賦課金登録状況一覧表示フラグ */
    showResult: boolean = false;

    /** 
     * コンストラクタ
     * @param {Router} router 
     * @param {UntypedFormBuilder} fb 
     * @param {UsedSgkc011aService} usedSgkc011aService 
     * @param {UsedSgkc012aService} usedSgkc012aService
     * @param {UsedSgkc019aService} usedSgkc019aService 
     * @param {UsedSgkc028aService} usedSgkc028aService 
     * @param {UsedSgkc016aService} usedSgkc016aService 
     * @param {ActivatedRoute} route 
     * @param {TimeApiService} timeApiService 
     * @param {CompleteDataService} completeDataService 
     * @memberof Sgkc034dComponent
     */
    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private usedSgkc011aService: UsedSgkc011aService,
        private usedSgkc012aService: UsedSgkc012aService,
        private usedSgkc019aService: UsedSgkc019aService,
        private usedSgkc028aService: UsedSgkc028aService,
        private usedSgkc016aService: UsedSgkc016aService,
        private route: ActivatedRoute,
        private timeApiService: TimeApiService
        , private completeDataService: CompleteDataService,
    ) {
        this.reEnergyTankaForm = this.fb.group({});
    }

    /** 
     * 初期化処理
     * @memberof Sgkc034dComponent
     */
    ngOnInit(): void {

        // 画面モードを取得
        this.route.paramMap.subscribe(params => {

            this.showResult = false;
            this.isVisibleApprovalInfo = false;
            this.isVisibleTankaInfo = false;
            // 画面表示モードの取得
            this.mode = params.get('mode');

            // スライド調整単価一覧取得API
            // データの購読設定
            this.usedSgkc011aService.slideTankaInfoChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(response => {
                    this.slideadjustmentunitpriceLstInformationlist = response;
                    this.showResult = true;
                });
            // 現在の年月を取得
            const nowYear: string = this.timeApiService.convertDateToString(new Date()).substring(0, 4);

            // システム年-10年の年月
            const pastYear: string = String(Number(nowYear) - 10);

            // リクエストを作成
            const slideadjustmentunitpriceSearchinfo: Sgkc011aReqSlideadjustmentunitpriceSearchinfoDto = {
                companygroupcode: CompanyGroupCode.saibukouri,// 会社グループコード
                companycode: CompanyCode.saibugas,// 会社コード
                energyClscode: EnergyTypeCode.denki,// エネルギー種別コード
                lpSalesformcode: null,// ＬＰ販売形態コード
                apprvAuthorityCode: null,// 承認部門
                slideadjustmentunitpriceCode: SlideadjustmentunitpriceCode.reEnergyTanka,// スライド単価調整コード
                applyYmStart: pastYear,// 適用年月（開始）
                applyYmEnd: "9999",// 適用年月（終了）
                apprvStatuscode: null // ステータス
            };
            const request: Sgkc011aRequest = {
                slideadjustmentunitpriceSearchinfo: slideadjustmentunitpriceSearchinfo
            };
            // サービス呼び出し
            this.usedSgkc011aService.searchSlideTankatable(request)
                .subscribe(response => {
                }, error => {
                });

            // スライド調整単価詳細取得API
            // データの購読設定
            this.usedSgkc012aService.slideTankatableChanges
                .pipe(takeUntil(this.onDestroy$))
                .subscribe(response => {
                    this.slideadjustmentunitpriceInfo = response.slideadjustmentunitpriceInfo
                    // スライド調整単価詳細取得APIで取得した承認ステータスコードを取得
                    this.apprvStatuscode = this.slideadjustmentunitpriceInfo.apprvStatuscode;

                    // 再エネ賦課金単価承認情報,再エネ賦課金単価情報コンポーネントの表示制御
                    if (this.mode === DisplayMode.create) {
                        if (this.apprvStatuscode === SearchStat.SHONINZUMI) {
                            this.isVisibleTankaInfo = true;
                        }
                    } else if (this.mode === DisplayMode.delete || this.mode === DisplayMode.approve) {
                        if (this.apprvStatuscode === SearchStat.mishonin) {
                            this.isVisibleApprovalInfo = true;
                            this.isVisibleTankaInfo = true;
                        }
                    } else if (this.mode === DisplayMode.read) {
                        this.isVisibleApprovalInfo = true;
                        this.isVisibleTankaInfo = true;
                    }
                });
            // リクエストを作成
            const slideadjustmentunitpriceShutokuinfo: Sgkc012aReqSlideadjustmentunitpriceShutokuinfoDto = {
                slideadjustmentunitpriceCode: SlideadjustmentunitpriceCode.reEnergyTanka,
                applyStartyearmonth: null,
                applyStartDate: null
            };
            const sgkc012aRequest: Sgkc012aRequest = {
                slideadjustmentunitpriceShutokuinfo: slideadjustmentunitpriceShutokuinfo
            };

            // サービスを呼び出し
            this.usedSgkc012aService.getSlideTankatableDetails(sgkc012aRequest)
                .subscribe(response => {
                }, error => {
                });
        });
    }

    /** 
      * 購読を停止する処理
      * @memberof Sgkc034dComponent
      */
    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    /** 
    * 登録ボタン押下時処理
    * @memberof Sgkc034dComponent
    */
    onClickRegistration(): void {
        // リクエストを作成する
        const form = this.reEnergyTankaForm.getRawValue().reEnergyTankaResultForm;

        const slideadjustmentunitpriceRegInfo: Sgkc019aReqSlideadjustmentunitpriceRegInfoDto = {
            slideadjustmentunitpriceCode: this.slideadjustmentunitpriceLstInformationlist[0].slideadjustmentunitpriceCode,
            applyStartyearmonth: form.applyYear,
            applyEndyearmonth: form.applyYear,
            applyStartDate: form.applyYear + "0501",
            applyEndDate: Number(form.applyYear) + 1 + "0501",
            slideadjustmentunitprice: !isNaN(Number(form.slideadjustmentunitprice)) ? Number(form.slideadjustmentunitprice) : null,
            slidecalculationelementsRegInformationlist: [],
        }
        const sgkc019aRequest: Sgkc019aRequest = {
            slideadjustmentunitpriceRegInfo: slideadjustmentunitpriceRegInfo
        }
        this.usedSgkc019aService.registSlideTankatable(sgkc019aRequest)
            .subscribe(response => {
                if (response) {
                    // 登録完了画面遷移
                    this.completeDataService.completeData = {
                        title: '再エネ賦課金単価登録完了',       // 画面タイトルを設定
                        message: '再エネ賦課金単価を登録しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc034d',                      // OK押下時に遷移する画面
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.mode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }

    /** 
    * 取消ボタン押下時処理
    * @memberof Sgkc034dComponent
    */
    onClickDelete(): void {
        // リクエストを作成する
        const form = this.reEnergyTankaForm.getRawValue().reEnergyTankaResultForm;
        const slideadjustmentunitpriceCancelInfo: Sgkc028aReqSlideadjustmentunitpriceCancelInfoDto = {
            slideadjustmentunitpriceCode: this.slideadjustmentunitpriceLstInformationlist[0].slideadjustmentunitpriceCode,
            applyStartyearmonth: form.applyYear,
            applyStartDate: this.slideadjustmentunitpriceInfo.applyStartDate,
            updateSrno: this.slideadjustmentunitpriceInfo.updateSrno
        }
        const sgkc028aRequest: Sgkc028aRequest = {
            slideadjustmentunitpriceCancelInfo: slideadjustmentunitpriceCancelInfo
        }
        this.usedSgkc028aService.deleteSlideTankatable(sgkc028aRequest)
            .subscribe(response => {
                if (response) {
                    // 取消完了画面遷移
                    this.completeDataService.completeData = {
                        title: '再エネ賦課金単価取消完了',       // 画面タイトルを設定
                        message: '再エネ賦課金単価を取消しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc034d',                      // OK押下時に遷移する画面
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.mode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }

    /** 
    * 承認ボタン押下時処理
    * @memberof Sgkc034dComponent
    */
    onClickApproval(): void {
        // リクエストを作成する
        const form = this.reEnergyTankaForm.getRawValue().reEnergyTankaResultForm;
        const slideadjustmentunitpriceApprvInfo: Sgkc016aReqSlideadjustmentunitpriceApprvInfoDto = {
            slideadjustmentunitpriceCode: this.slideadjustmentunitpriceLstInformationlist[0].slideadjustmentunitpriceCode,
            applyStartyearmonth: form.applyYear,
            applyStartDate: this.slideadjustmentunitpriceInfo.applyStartDate,
            updateSrno: this.slideadjustmentunitpriceInfo.updateSrno
        }
        const sgkc016aRequest: Sgkc016aRequest = {
            slideadjustmentunitpriceApprvInfo: slideadjustmentunitpriceApprvInfo
        }
        this.usedSgkc016aService.approveSlideTankatable(sgkc016aRequest)
            .subscribe(response => {
                if (response) {
                    // 承認完了画面遷移
                    this.completeDataService.completeData = {
                        title: '再エネ賦課金単価承認完了',       // 画面タイトルを設定
                        message: '再エネ賦課金単価を承認しました', // 画面に表示するメッセージを設定
                        next: '/sgkc/sgkc034d',                      // OK押下時に遷移する画面
                        koumokuList: [], // 画面に表示する情報
                        queryParams: {
                            "mode": this.mode,
                        },
                    }
                    this.router.navigate(['/sgkz003d']);
                }
            }, error => {
            });
    }

    /** 
     * 行ダブルクリック時処理
     * @param {SlideadjustmentunitpriceLstInfoDto} row 
     * @memberof Sgkc034dComponent
     */
    onDbClickRow(row: SlideadjustmentunitpriceLstInfoDto): void {
        // リクエストを作成
        const slideadjustmentunitpriceShutokuinfo: Sgkc012aReqSlideadjustmentunitpriceShutokuinfoDto = {
            slideadjustmentunitpriceCode: this.slideadjustmentunitpriceLstInformationlist[0].slideadjustmentunitpriceCode,
            applyStartyearmonth: row.applyStartyearmonth,
            applyStartDate: row.applyStartDate
        };
        const sgkc012aRequest: Sgkc012aRequest = {
            slideadjustmentunitpriceShutokuinfo: slideadjustmentunitpriceShutokuinfo
        };
        // サービスを呼び出し
        this.usedSgkc012aService.getSlideTankatableDetails(sgkc012aRequest)
            .subscribe(response => {
            }, error => {
            });
    }
}
